import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgMailSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1 4.33008L8 8L15 4.33008M1 2.5H15V10.5C15 11.2956 14.6839 12.0587 14.1213 12.6213C13.5587 13.1839 12.7956 13.5 12 13.5H1V2.5Z"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
    />
  </svg>
);

SvgMailSmall.displayName = 'SvgMailSmall';
const MailSmall = withForgeIconProps(SvgMailSmall, {
  name: 'Mail',
  usage: 'Use to open an email or inbox, or to indicate an email address.',
  related: 'envelope',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default MailSmall;
